import { Grid, Stack, Typography } from "@mui/material";
import {
  RHFAutocomplete,
  RHFCheckbox,
  RHFRadioGroup,
  RHFTextField,
} from "../../../../../RHFComponents/RHFComponents";
import MedintFormInterface from "../../../../../../services/medintInterfaces";
import { UseFormReturn } from "react-hook-form";
import { useContext } from "react";
import { MedintDataContext } from "../../../../Context/MedintContextWrapper";

const FormFatturazione = (props: {
  methods: UseFormReturn<MedintFormInterface>;
}) => {
  const context = useContext(MedintDataContext);

  return (
    <Grid
      container
      padding={2}
      mt={2}
      sx={{
        borderRadius: "4px",
        border: "1px solid #CCC",
      }}
    >
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: "bold", fontSize: "20px", pl: 1 }}>
          Collaboratori / Incassi conto terzi
        </Typography>
      </Grid>
      <Grid item xs={12} mt={2} pl={1}>
        <Stack direction={"row"} >
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              width: "30%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            Abilita procedura collaboratori
          </Typography>
          <RHFRadioGroup
            name="medIntDettaglio.abProcCollaboratori"
            control={props.methods.control}
            options={[
              { label: "Disabilitata", value: "0" },
              { label: "Abilitato no doc", value: "1" },
              { label: "Abilitato con doc", value: "2" },
            ]}
            row
            sx={{
              width: "100%",
              display: "flex",
              "& .MuiFormControlLabel-root": {
                pl: 3.5,
                flex: 1,
                justifyContent: "flex-start",
                alignContent: "center",
              },
              "& .MuiTypography-root": {
                color: "rgba(0, 0, 0, 0.70)",
                fontSize: "14px",
              },
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={6} p={1} mt={1} />
      <Grid item xs={6} p={1} mt={1}>
        <RHFCheckbox
          name="medIntDettaglio.abIncTerz"
          label="Permetti emissione incassi c/terzi"
          control={props.methods.control}
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFTextField
          name="medIntDettaglio.suffissoDocumenti"
          control={props.methods.control}
          label="Suffisso memorizzazione documenti"
          fullWidth
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFCheckbox
          name="medIntDettaglio.numerazioneManuale"
          label="Numerazione documenti assegnata manualmente"
          control={props.methods.control}
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFTextField
          name="medIntDettaglio.contrPrevidenziale"
          control={props.methods.control}
          label="% Contributo previdenziale"
          fullWidth
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFCheckbox
          name="medIntDettaglio.intestazioneDoc"
          label="Intestazione documenti con residenza fiscale"
          control={props.methods.control}
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFTextField
          name="medIntDettaglio.filialeContabile"
          control={props.methods.control}
          label="Filiale contabile collaboratori"
          fullWidth
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFCheckbox
          name="medIntDettaglio.swFattElettronica"
          label="Fatturazione elettronica"
          control={props.methods.control}
        />
      </Grid>
      <Grid item xs={12} p={1} pb={2}>
        <RHFAutocomplete
          control={props.methods.control}
          name="medIntDettaglio.codIva"
          label="Codice IVA"
          options={context?.listaCodIva ?? []}
          keyField="id"
          getOptionLabel={(d: any) =>
            `${d?.codCodIva ?? "N/a codice"} - ${d?.descodIva ?? "N/A desc codIva"}`.trim()
          }
          mapIn={(id, opts) =>
            opts.find((o: any) => String(o?.codCodIva) === String(id)) ?? null
          }
          mapOut={(opt: any) => String(opt?.codCodIva ?? "") || null}
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFTextField
          name="medIntDettaglio.titoloDoc"
          control={props.methods.control}
          label="Titolo intestazione documento"
          fullWidth
        />
      </Grid>
      <Grid item xs={6} p={1}>
        <RHFTextField
          name="medIntDettaglio.codiceStruttura"
          control={props.methods.control}
          label="Codice struttura D.Is 175/2014"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} p={1}>
        <RHFAutocomplete
          control={props.methods.control}
          name="medIntDettaglio.voceSaldo"
          label="Voce saldo collaboratori"
          options={context?.listaSaldoCollaboratori ?? []}
          keyField="id"
          getOptionLabel={(d: any) =>
            `${d?.codVocAdd ?? "N/a codice"} - ${d?.desVocAdd ?? "N/a descrizione"}`.trim()
          }
          mapIn={(id, opts) =>
            opts.find((o: any) => String(o?.codVocAdd) === String(id)) ?? null
          }
          mapOut={(opt: any) => String(opt?.codVocAdd ?? "") || null}
        />
      </Grid>
      <Grid item xs={12} p={1} pb={2}>
        <RHFAutocomplete
          control={props.methods.control}
          name="medIntDettaglio.bancaAppoggio"
          label="Banca di appoggio"
          options={context?.listaBanche ?? []}
          keyField="id"
          getOptionLabel={(d: any) =>
            `${d?.codBanche ?? "N/a codice"} - ${d?.desBanche ?? "N/a descr banca"}`.trim()
          }
          mapIn={(id, opts) => {
            // Gestione dell'assegnazione delle valorizzazioni dei field ABI e CAB a seconda delle selezioni
            const result =
              opts.find((o: any) => String(o?.codBanche) === String(id)) ??
              null;
            props.methods.setValue(
              "medIntDettaglio.coordBanc.banchxabi",
              result?.ABI ?? "",
            );
            props.methods.setValue(
              "medIntDettaglio.coordBanc.banchxcab",
              result?.CAB ?? "",
            );
            console.log({ result });
            return result;
          }}
          mapOut={(opt: any) => String(opt?.codBanche ?? "") || null}
        />
      </Grid>

      {/* COORDINATE BANCARIE */}
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
            width: "30%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            pl: 1,
            pb: 1,
          }}
        >
          Coordinate Bancarie / Iban
        </Typography>
      </Grid>
      <Grid item xs={12} mr={1} ml={1}>
        <Grid
          container
          p={1}
          sx={{
            borderRadius: "4px",
            border: "1px solid #CCC",
          }}
        >
          <Grid item xs={2} p={1}>
            {/* SLOT UNO SIGLA IBAN */}
            <RHFTextField
              name="medIntDettaglio.coordBanc.siglaIban"
              inputProps={{ maxLength: 2 }}
              control={props.methods.control}
              label="Codice Paese"
              fullWidth
            />
          </Grid>
          {/* SLOT DUE CTRIBAN */}
          <Grid item xs={2} p={1}>
            <RHFTextField
              name="medIntDettaglio.coordBanc.ctrIban"
              inputProps={{ maxLength: 2 }}
              control={props.methods.control}
              label="Cifre di Controllo"
              fullWidth
            />
          </Grid>
          {/* SLOT TRE CODICECIN */}
          <Grid item xs={1} p={1}>
            <RHFTextField
              name="medIntDettaglio.coordBanc.codiceCin"
              inputProps={{ maxLength: 1 }}
              control={props.methods.control}
              label="CIN"
              fullWidth
            />
          </Grid>
          {/* SLOT QUATTRO BANCHXABI */}
          <Grid item xs={2} p={1}>
            <RHFTextField
              name="medIntDettaglio.coordBanc.banchxabi"
              disabled
              control={props.methods.control}
              label="Codice Abi"
              fullWidth
            />
          </Grid>
          {/* SLOT CINQUE BANCHXCAB */}
          <Grid item xs={2} p={1}>
            <RHFTextField
              name="medIntDettaglio.coordBanc.banchxcab"
              disabled
              control={props.methods.control}
              label="Codice Cab"
              fullWidth
            />
          </Grid>
          {/* SLOT SESTO BANCHXABI */}
          <Grid item xs={3} p={1}>
            <RHFTextField
              name="medIntDettaglio.coordBanc.contoCorrente"
              inputProps={{ maxLength: 12 }}
              label="Numero Conto Corrente"
              control={props.methods.control}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormFatturazione;
